export const PERCENT_DECIMALS_MULTIPLIER = 100

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000
